import { Component, input, inject, computed } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

import { ICONS, IconName } from "./icons";

@Component({
    selector: "mp-icon",
    templateUrl: "./icon.component.html",
    styleUrls: ["./icon.component.scss"]
})
export class MpIconComponent {
    name = input.required<IconName>();

    svgContent = computed(() => {
        const icon = ICONS[this.name()];
        if (!icon) {
            console.warn(`Icon ${this.name()} not found`);
            return "";
        }
        return this.sanitizer.bypassSecurityTrustHtml(icon);
    });

    private sanitizer = inject(DomSanitizer);
}
